module.exports = __webpack_public_path__ + "img/banner_body-link_02.33ed4a10.svg";